import React from "react";
import { Route } from "react-router-dom";

import Home from "./Home";
import Toplist from "./Toplist";
import StreamChecker from "./StreamChecker";
import Matches from "./Matches";
import Tools from "./Tools";
import TwitterRanking from "./TwitterRanking";

class App extends React.Component {
  render() {
    return (
      <>
        <Route exact path="/" component={Home} />
        <Route path="/toplist/:region" component={Toplist} />
        <Route path="/stream/:region" component={StreamChecker} />
        <Route path="/matches" component={Matches} />
        <Route path="/tools" component={Tools} />
        <Route path="/twitter" component={TwitterRanking} />
      </>
    );
  }
}

export default App;
